module.exports = __webpack_public_path__ + "static/img/Nine of Pentacles.f432ce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Nine of Pentacles.jpg
// module id = 1284
// module chunks = 0